/** Portal target inside the sticky app chrome for digest profile chips. */
export const LITPULSE_DIGEST_SLOT_ID = 'litpulse-digest-slot';
